/**
 * useRecommendations Hook — TanStack Query 推荐封装
 */

import { useQuery } from '@tanstack/react-query';
import { getRecommendDestinations, getRecommendPois, getUserTravelProfile, type Destination, type Poi, type UserTravelProfile } from '@/infrastructure/api/recommendations';

export function useRecommendDestinations(userId?: number, city?: string, limit = 10) {
  return useQuery<Destination[]>({
    queryKey: ['recommendations', 'destinations', userId, city, limit],
    queryFn: () => getRecommendDestinations(userId, city, limit),
    staleTime: 10 * 60 * 1000,
  });
}

export function useRecommendPois(userId?: number, city?: string, limit = 10) {
  return useQuery<Poi[]>({
    queryKey: ['recommendations', 'pois', userId, city, limit],
    queryFn: () => getRecommendPois(userId, city, limit),
    staleTime: 10 * 60 * 1000,
  });
}

export function useUserTravelProfile(userId?: number) {
  return useQuery<UserTravelProfile | null>({
    queryKey: ['recommendations', 'profile', userId],
    queryFn: () => userId ? getUserTravelProfile(userId) : Promise.resolve(null),
    enabled: !!userId,
    staleTime: 30 * 60 * 1000,
  });
}
